import { render, staticRenderFns } from "./navDashboardMinorCard.vue?vue&type=template&id=2b67d5f8&scoped=true&"
import script from "./navDashboardMinorCard.vue?vue&type=script&lang=js&"
export * from "./navDashboardMinorCard.vue?vue&type=script&lang=js&"
import style0 from "./navDashboardMinorCard.vue?vue&type=style&index=0&id=2b67d5f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b67d5f8",
  null
  
)

component.options.__file = "navDashboardMinorCard.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardTitle,
  VIcon,
  VSpacer,
})
